import React from 'react'
import styled from "styled-components";
import media from "styles/media";
import colors from "styles/colors";
import text from "styles/text";
import GlobalButton from './buttons/GlobalButton';
import useMedia from 'utils/useMedia'

const ImageCTA = ({content}) => {
  
   const bgImg = useMedia(
    content?.backgroundImages[0].sourceUrl,
    content?.backgroundImages[0].sourceUrl,
    content?.backgroundImages[1].sourceUrl,
    content?.backgroundImages[2].sourceUrl,
    )
  return (
    <Wrapper>
      <CtaWrapper $bgimg={bgImg}>
        <ContentDiv $textcolor={content.textColor}>
            <Header>
                {content.header}
            </Header>
            <GlobalButton fill href={content.linkUrl}>{content.linkText}</GlobalButton>
        </ContentDiv>
      </CtaWrapper>
    </Wrapper>
  );
}

export default ImageCTA
const Header= styled.h3`
${text.h3};

${media.mobile}{
  ${text.h4};
}
`
const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.778vw;
  width: 31.111vw;
  color: ${props => props.$textcolor === 'Light' ? colors.white : colors.black};

  ${media.fullWidth} {
    gap: 40px;
    width: 448px;
  }

  ${media.tablet} {
    gap:3.906vw;
    width:39.234vw;
  }

  ${media.mobile} {
    gap:5.607vw;
    width:49.402vw;
  }
`;
const CtaWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  background-image: ${(props) =>
    props.$bgimg ? `url(${props.$bgimg})` : `unset`};
  background-size: cover;
  background-repeat: no-repeat;
  width: 88.889vw;
  height: 32.292vw;
  border-radius: 1.667vw;
  padding: 6.944vw 4.722vw 12.5vw 4.722vw;

  ${media.fullWidth} {
    width: 1280px;
    height: 465px;
    border-radius: 24px;
    padding: 100px 68px 180px 68px;
  }

  ${media.tablet} {
    width:94.727vw;
    height: 45.41vw;
    border-radius: 2.344vw;
    padding: 9.766vw 6.348vw 25.586vw 6.348vw;
  }

  ${media.mobile} {
    width: 96.262vw;
    height:85.514vw;
    border-radius:5.607vw;
    padding: 40px 10px;
  }
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
`;